import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Footer: React.FC = () => {
  const { t } = useTranslation()

  return (
    <footer className="flex-shrink-0 bg-white border-t border-border py-4">
      <div className="px-4 lg:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-text-light">{t('footer.copyright')}</p>

          <div className="flex items-center gap-6">
            <a
              href="https://github.com/hanyitim/zitie/issues"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-text-secondary hover:text-primary transition-colors"
            >
              {t('footer.feedback')}
            </a>
            <a
              href="https://github.com/hanyitim/zitie"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-text-secondary hover:text-primary transition-colors"
            >
              {t('footer.github')}
            </a>
            <Link to="/terms" className="text-sm text-text-secondary hover:text-primary transition-colors">
              {t('footer.terms')}
            </Link>
            <Link to="/privacy" className="text-sm text-text-secondary hover:text-primary transition-colors">
              {t('footer.privacy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
